import './shipping.css';

const ShippingPolicy = () => {
    return (
        <div className="payment">
            <h2>Shipping & Payment: Flexible, Fair, and Focused on You!</h2>
            <p>Getting your goods to you efficiently and securely is our top priority. We've built our shipping and payment policies to be clear, flexible, and to foster strong, lasting partnerships.</p>
            
                <h2>Payment Terms Designed for Trust</h2>
                <ul>
                    <li><strong>Sea Cargo?</strong> We operate on a <strong>70% advance payment</strong>, with the remaining <strong>30% due against documents.</strong> This balanced approach ensures a smooth process for both parties.</li><br></br>
                    <li><strong>Air Cargo?</strong> For the speed and precision of air shipments, we require <strong>100% advance payment.</strong></li>
                </ul>
            
            <div className="intro">
                <h2>First-time working with us? </h2>
                <p>We believe in building trust from the ground up. If your initial shipment goes seamlessly (and we're confident it will!), we're open to discussing more flexible terms for future orders, based on our growing understanding and relationship. Your success is our success!</p>
            </div>

            <div className="packaging">
                <h2>Custom Packaging & Branding</h2>
                <p>Looking to make your brand shine? Any investment in packing materials or specialized cylinders for your brand is at your expense. This ensures you have complete control and ownership over your unique branding, while we handle the expert packing and logistics.
                    Got questions about a specific shipment or custom branding? We're always here to help!
                </p>
            </div>
        </div>

    );
}

export default ShippingPolicy;